<template>
    <div v-if="articlesSearchResults.length > 0" class="suggest-result">
        <h3>{{ __('frontend_js.search.articles') }}</h3>
        <ul>
            <li v-for="article in articlesSearchResults" :key="article.id">
                <a :href="article.slug" class="hover-remove-underline text-dark">{{ article.title }} </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        articlesSearchResults: {
            type: Array,
        },
    },
};
</script>

<style>
</style>
